import { DeleteOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { ConfirmAction, } from 'components';
import { useDeleteToolTestMutation } from 'app/services/tools';
import { ToolTest } from 'app/types/tool';
import { formatDate, formats } from 'utils/datetime';

const DeleteTest = ({ test }: { test: ToolTest }) => {
  const { t } = useTranslation();
  const [ deleteTest, meta ] = useDeleteToolTestMutation();

  const handleRemoveClick = async (test: ToolTest) => {
    await deleteTest(test.Id).unwrap();
  };

  const label = `${formatDate(test.CreatedAt, formats.DD_MM_YYYY_HH_mm)} ${t('entities.tooltest.title').toLowerCase()}`;

  return <ConfirmAction
    callback={() => handleRemoveClick(test)}
    successMessage={t('common.deletesuccess', { content: label })}
    confirmMessage={t('common.deleteconfirm', { content: label })}
    meta={meta}
    tooltipButtonProps={{
      title: t('common.delete'),
      minimized: true,
      buttonProps: {
        danger: true,
        type: 'link',
        icon: <DeleteOutlined />,
      }
    }}
  />;


};

export default DeleteTest;